import { Model } from 'miragejs';
import { DakokuTable, KojiTable } from './mock-data-type';

export const mockModels = {
  kojiTable: Model.extend<Partial<KojiTable>>({}),
  dakokuTable: Model.extend<Partial<DakokuTable>>({}),
};
